import React from "react";
import { Link } from "react-router-dom";
import { getValue } from "../../utils/json/parseJSONValue";
import AvatarName from "../UniversalComponents/AvatarName";

const TopTitle = ({ headerProps }) => {
  const { name, groupname, type, pt, pb, icon, url, nameletter, top } = headerProps;

  return (
    <div className={`flex items-center gap-x-1 ${icon ? "-ml-3" : "ml-0"} z-[1200]`} style={{ paddingTop: `${pt}px` }}>
      {icon && (
        <Link
          to={url}
          className="cuthome-icon rounded-sm bg-primary-30 hover:bg-primary-50 transition duration-600 ease-in-out"
        >
          <span>{icon}</span>
        </Link>
      )}
      {/* {nameletter && <span className="nml-circle">{nameletter}</span>} */}
      {nameletter && (
        <AvatarName name={nameletter} size="large" bgColor={"#ffffff"} textColor={"#1D4469"} borderColor={"#1d4469"} />
      )}

      {name && groupname ? (
        <span className="flex items-start ml-1">
          <span className="me-2 ">
            <p className="font-medium text-lg text-203C50 capitalize mb-0">{getValue(groupname)}</p>
            <p className="text-xs text-red-400 capitalize">{type}</p>
          </span>
          <span className="flex items-start">
            <span className="me-2">-</span>
            <span>{name}</span>
          </span>
        </span>
      ) : (
        <span className="text-primary text-20 font-medium font-Vietnam">{name}</span>
      )}
    </div>
  );
};

export default TopTitle;
